import { combineReducers } from 'redux';
import productItemsReducer from './productItems/reducer';
import cartReducer from './cart/reducer';

const rootReducer = combineReducers({
    productItems: productItemsReducer,
    cart: cartReducer,
});

export default rootReducer;